import axios from "axios";
import { toast } from "sonner";

// Alerte quand un déplacement de mission tombe sur un jour où l'employé est FULL / en congés.
// Propose « Déplacer quand même » puis rejoue la requête avec ?force=true.
let installed = false;

export const installMoveGuard = () => {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(undefined, async (error) => {
    const detail = error.response?.data?.detail;
    const config = error.config;
    if (error.response?.status !== 409 || detail?.type !== "employee_unavailable" || detail?.context !== "move" || !config) {
      return Promise.reject(error);
    }
    const ok = window.confirm(`⚠️ ${detail.message}\n\nDéplacer quand même ?`);
    if (!ok) {
      toast.info("Déplacement annulé");
      error.moveCancelled = true;
      return Promise.reject(error);
    }
    return axios({ ...config, params: { ...(config.params || {}), force: true } });
  });
};
